module.exports = __webpack_public_path__ + "static/media/a-5-d.a4fe50aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessroies/a-5-d.jpg
// module id = 1106
// module chunks = 33